import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron_right",
  "use": "chevron_right-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"chevron_right\"><path d=\"M13.41 9 7.7 14.71a.996.996 0 1 1-1.41-1.41l4.29-4.29-4.29-4.3A.996.996 0 1 1 7.7 3.3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol